import { initialFerryPassageValues, OrderPointType } from './OrderPointForm'
import moment from 'moment'
import { momentToISOLocalDate, momentToISOLocalTime } from 'utils/date'
import { v4 as uuidv4 } from 'uuid'

export function newFerryPassagePointFormValues () {
  return {
    id: uuidv4(),
    type: OrderPointType.FerryPassage,
    visibleForClient: false,
    ferryPassageDetails: {
      ...initialFerryPassageValues
    }
  }
}

export function newCustomsControlPointFormValues () {
  return {
    id: uuidv4(),
    type: OrderPointType.CustomsControl,
    visibleForClient: false,
    customsControlDetails: {
      customsAgencyName: '',
      address: {
        address: '',
        city: '',
        countryCode: 'PL',
        zipCode: ''
      },
      contactPersonName: '',
      additionalInfo: ''
    }
  }
}

export function newCustomIntermediatePointFormValues () {
  return {
    id: uuidv4(),
    type: OrderPointType.Custom,
    visibleForClient: false,
    customIntermediatePointDetails: {
      address: {
        address: '',
        city: '',
        countryCode: 'PL',
        zipCode: ''
      },
      description: ''
    }
  }
}

const emptyDeliveryPointDetails = {
  fromDate: null,
  fromTime: '',
  toDate: null,
  toTime: '',
  companyName: '',
  cityName: '',
  country: 'PL',
  address: '',
  zipCode: '',
  additionalInfo: '',
  optionalFeatures: [],
  cargoDetails: {
    name: '',
    wrappingType: '',
    quantity: '',
    weight: '',
    dispenser: ''
  }
}

export function newLoadingDeliveryPointFormValues () {
  const fromMoment = moment().hours(8).startOf('hour')
  const toMoment = moment().hours(16).startOf('hour')
  return {
    id: uuidv4(),
    type: OrderPointType.Loading,
    deliveryPointDetails: {
      ...emptyDeliveryPointDetails,
      fromDate: momentToISOLocalDate(fromMoment),
      fromTime: momentToISOLocalTime(fromMoment),
      toDate: momentToISOLocalDate(toMoment),
      toTime: momentToISOLocalTime(toMoment)
    }
  }
}

export function newUnloadingDeliveryPointFormValues () {
  const fromMoment = moment().add(1, 'day').hours(8).startOf('hour')
  const toMoment = moment().add(1, 'day').hours(12).startOf('hour')
  return {
    id: uuidv4(),
    type: OrderPointType.Unloading,
    deliveryPointDetails: {
      ...emptyDeliveryPointDetails,
      fromDate: momentToISOLocalDate(fromMoment),
      fromTime: momentToISOLocalTime(fromMoment),
      toDate: momentToISOLocalDate(toMoment),
      toTime: momentToISOLocalTime(toMoment)
    }
  }
}

export function newUnloadingDeliveryPointFormValuesFromLoadingPoint (loadingDeliveryPoint) {
  const defaultUnloadingPoint = newUnloadingDeliveryPointFormValues()
  const loadingDeliveryPointDetails = loadingDeliveryPoint.deliveryPointDetails
  return {
    ...defaultUnloadingPoint,
    deliveryPointDetails: {
      ...defaultUnloadingPoint.deliveryPointDetails,
      cargoDetails: {
        ...defaultUnloadingPoint.deliveryPointDetails.cargoDetails,
        name: loadingDeliveryPointDetails.cargoDetails.name,
        wrappingType: loadingDeliveryPointDetails.cargoDetails.wrappingType,
        quantity: loadingDeliveryPointDetails.cargoDetails.quantity,
        weight: loadingDeliveryPointDetails.cargoDetails.weight
      },
      optionalFeatures: loadingDeliveryPointDetails.optionalFeatures
    }
  }
}

export function findNthPointOfType (orderPoints, type, n) {
  let curr = 0
  for (let i = 0; i < orderPoints.length; i++) {
    const p = orderPoints[i]
    if (p.type === type) {
      curr++
      if (curr === n) {
        return p
      }
    }
  }
  return null
}

export function getNumberOfPointAtIndex (orderPoints, index) {
  const type = orderPoints[index].type
  let number = 1
  for (let i = 0; i < index; i++) {
    if (orderPoints[i].type === type) {
      number++
    }
  }
  return number
}
